import { Radio } from 'antd';
import styled from 'styled-components';

export const StyledRadio = styled(Radio)``;
